// extracted by mini-css-extract-plugin
export default {"fix":"SideBar_fix__WsrRJ","color":"SideBar_color__pniaJ","color3":"SideBar_color3__YhS2u"};